import classNames from 'classnames'
import React, { ComponentType, InputHTMLAttributes } from 'react'

import type { IconProps } from '../../icon/icon.js'

export interface ToggleProps extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    'onChange' | 'checked' | 'type' | 'value'
> {
    value: boolean
    onChange: (nextValue: boolean) => void
    onText?: string
    offText?: string
    isDisabled?: boolean
    IconOn?: ComponentType<IconProps>
    IconOff?: ComponentType<IconProps>
}

export const Toggle = ({
    value,
    onChange,
    onText,
    offText,
    isDisabled,
    IconOn,
    IconOff,
    ...rest
}: ToggleProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked)
    }

    return (
        <label className={classNames('toggle', value && 'is-on', isDisabled && 'is-disabled')}>
            <input
                type="checkbox"
                className="toggle__input"
                checked={value}
                disabled={isDisabled}
                onChange={!isDisabled ? handleChange : undefined}
                {...rest}
            />

            <span className="toggle__thumb">
                {value && IconOn && <IconOn className="toggle__icon toggle__icon--on" />}
                {!value && IconOff && <IconOff className="toggle__icon toggle__icon--off" />}
                <span className="toggle__label">{value ? onText : offText}</span>
            </span>
        </label>
    )
}
